<div class="main">
  <div class="header py-7 py-lg-8">
    <div class="container">
      <div class="header-body text-center mb-4"></div>
    </div>
  </div>

  <!-- Page content -->
  <div class="container mt--8 pb-5">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6">
        <div class="d-flex w-100 h-200">
          <div class="text-center mb-6 ">
            <img
              src="assets/img/brand/logo.png"
              width="90%"
              height="auto"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-5 col-md-6" style="margin-top:-40px;margin-bottom:60px">
        <div class="card bg-white-trans border-0">
          <div class="card-body px-lg-5 py-lg-4">
            <div class="text-center mb-4">
              <img
                src="assets/img/icons/user.png"
                width="130px"
                height="130px"
                alt=""
              />
            </div>
            <div class="mb-5">
              <div class="mb-2">
                <div class="text-center">
                  <h2>Reset Password</h2>
                </div>
                <div class="input-container">
                  <form>
                    <div class="form-group">
                      <input
                        #dataInput
                        type="password"
                        name="password"
                        id="password"
                        class="form-control form-control-lg"
                        formControlName="email"
                        placeholder="Enter your new password"
                        require
                      />
                      <!-- <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert">
                    <div *ngIf="email.errors.required">* Email is required *</div>
                    <div *ngIf="email.errors.email">* Your email is incorrect!! *</div>
                  </div> -->

                      <div class="confirmpass">
                        <input
                          #dataConfirm
                          type="password"
                          name="passwordconfirm"
                          id="passwordconfirm"
                          class="form-control form-control-lg"
                          formControlName="email"
                          placeholder="Confirm your password"
                          require
                        />
                      </div>
                    </div>
                  </form>
                </div>
                <div class="form-group d-flex justify-content-center py-4">
                  <button
                    type="button"
                    class="btn btn1 text-white"
                    (click)="
                      checknewpassword(dataInput.value, dataConfirm.value)
                    "
                  >
                    Save Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
